import React from 'react';
import ExhibitionCard from './ExhibitionCard';

const ExhibitionGrid = ({ exhibitions }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {exhibitions.map(exhibition => (
        <ExhibitionCard key={exhibition.id} exhibition={exhibition} />
      ))}
    </div>
  );
};

export default ExhibitionGrid;
